import {useBoldInputStyle} from 'components/common/useBoldInputStyle'
import * as React from 'react'
import {useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import * as yup from 'yup'

export default function BusinessNoInput() {
  const createMemberInfo = useFormContext()
  const classes = useBoldInputStyle()
  const {t} = useTranslation()
  const schema = yup.object().shape({
    code: yup.string(),
  })

  const {
    formState: {errors},
  } = useFormContext()

  return (
    <div className={classes.root}>
      <div className={classes.labelWrapContainer}>
        <p className={classes.inputLabel} style={{padding: '5px 0'}}>
          {t('IBusinessNo')}
        </p>
      </div>
      <input
        placeholder={t('IRegisterBusinessNo')}
        className={classes.input}
        {...createMemberInfo.register('businessNo', {
          validate: (code) => schema.validate({code}).catch((e) => e.errors[0]),
        })}
      />
      {errors.businessNo && (
        <span className={classes.errorText}>{errors.businessNo.message}</span>
      )}
    </div>
  )
}
